import './i18n';
import './App.scss';

import ApiSection from './components/ApiSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FlexibilitySection from './components/FlexibilitySection';
import Header from './components/Header';
import Hero from './components/Hero';
import Process from './components/Process';
import RailsSection from './components/RailsSection';
import Services from './components/Services';
import Showcase from './components/Showcase';
import Solutions from './components/Solutions';
import Technology from './components/Technology';
import TrustedStrip from './components/TrustedStrip';

function App() {
  return (
    <div className="app">
      <Header />

      <main id="top">
        <Hero />
        <TrustedStrip />
        <Services />
        <Technology />
        <RailsSection />
        <Solutions />
        <ApiSection />
        <Process />
        <Showcase />
        <FlexibilitySection />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;